<template>
  <vue-final-modal 
    v-model="showM" 
    classes="modal-container" 
    content-class="modal-content-f w600"
  >
    <div class="modal-header">
      <b>{{ webinar.id ? 'Upravit webinar' : 'Nový webinar' }}</b>
      <button type="button" class="close" @click.prevent="hideModal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal__content">
      <div class="form-group">
        <label>Název</label>
        <input 
          type="text" 
          v-model="webinar.name" 
          class="form-control"
          placeholder="Zadejte název"
        />
      </div>

      <div class="form-group">
        <label>SE List ID</label>
        <input 
          type="number" 
          v-model.number="webinar.se_list_id" 
          class="form-control"
          placeholder="Zadejte SE List ID"
        />
      </div>

      <div class="form-group">
        <label>Webinar ID</label>
        <input 
          type="number" 
          v-model.number="webinar.webinar_id" 
          class="form-control"
          placeholder="Zadejte Webinar ID"
        />
      </div>

      <div v-if="errors.length > 0" class="alert alert-danger">
        <ul class="mb-0">
          <li v-for="error in errors" :key="error">{{ error }}</li>
        </ul>
      </div>
    </div>

    <div class="modal__action">
      <button class="btn btn-primary" @click="handleSaveChanges">
        Uložit změny
      </button>
      <button class="btn btn-outline-dark ml-4" @click="hideModal">
        Zrušit
      </button>
    </div>
  </vue-final-modal>
</template>

<script>
import axios from "axios";
import modalKkMixin from "../conversation-club/modal-kk-mixin.js";

export default {
  name: "modal-form",
  mixins: [modalKkMixin],
  props: ['webinar'],
  data() {
    return {
      errors: []
    };
  },
  methods: {
    async handleSaveChanges() {
      this.errors = [];
      
      try {
        if (this.webinar.id) {
          await axios.put(`/ever_webinars/${this.webinar.id}`, {
            ever_webinar: {
              name: this.webinar.name,
              se_list_id: this.webinar.se_list_id,
              webinar_id: this.webinar.webinar_id
            }
          });
        } else {
          await axios.post('/ever_webinars', {
            ever_webinar: {
              name: this.webinar.name,
              se_list_id: this.webinar.se_list_id,
              webinar_id: this.webinar.webinar_id
            }
          });
        }
        
        this.hideModal();
        this.$emit('webinarUpdated');
      } catch (error) {
        if (error.response && error.response.data.errors) {
          this.errors = error.response.data.errors;
        } else {
          this.errors = ['Nastala chyba při ukládání'];
        }
      }
    }
  }
};
</script>

<style scoped>
</style>
